import React from "react";
import DefaultCard from "./default-card";

import ucaEnv from "../../../../common/env/env-uca";
import { useApi } from "../../../../hooks";
import { CommonModule } from "uca-react-containers-library";

const RewardsCard = ({ category, banner, isGuest }) => {
  let apiResponse;
  if (!isGuest) {
    const {
      appData: { env, platform },
    } = CommonModule.useApp();
    const environmentVariables = ucaEnv(banner, env, platform);
    const { data } = useApi(
      `${environmentVariables.REWARDS_PAGE_BASE_API}/rewards/balance`
    );
    apiResponse = data;
  }

  return (
    <DefaultCard
      category={{
        ...category,
        desc:
          !isGuest && apiResponse
            ? `Points balance: ${apiResponse.points}`
            : category.desc,
        link: {
          ...category.link,
          href: isGuest ? "/account/sign-in.html" : category.link.href,
          defaultUrl: category.link.href,
        },
      }}
    />
  );
};

export default RewardsCard;
